import React from 'react';
import { View } from '@uncinc/react-drupal-core';
import { Fade } from 'react-awesome-reveal';
import Button from '../../../../components/Button';

import {
  Container,
} from '../../../../components';

import './style.scss';

const ParagraphNewsSelection = ({ entity, paragraphKey }) => {

  const title = entity.getIn(['field_title', 0, 'value'], '');
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));

  return (
    <div id={paragraphKey} className="Paragraph ParagraphNewsSelection">
      <Fade triggerOnce bottom distance="50px" duration={500}>
        <View id="news" display="block_1" title={title} />
        <Container>
          <div className="ParagraphNewsSelection__button">
            { link && (
              <Button
                href={link}
                primary
                withIcon
                buttonIcon
              >
                {entity.getIn(['field_link', 0, 'title'], '')}
              </Button>
            )}
          </div>
        </Container>
      </Fade>
    </div>
  );
};

export default ParagraphNewsSelection;
